import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import { OrganizationUserDto } from "../dto/UserDto";

import { OrganizationPublicId, UserRole } from "../Types";

type CreateUserRequest = {
  email: string;
  firstName: string;
  lastName: string;
  role?: UserRole;
};

export class OrganizationUserController {
  constructor(private axios: AxiosInstance) {}

  public getUsers = async (organizationId: OrganizationPublicId, extendedOrgs: Boolean = false) => {
    const url = Helpers.organizationAdminUsers(organizationId);
    const params = { extendedOrgs };
    const response = await this.axios.get<OrganizationUserDto[]>(url, { params });

    return response.data as OrganizationUserDto[];
  };

  public inviteUser = async (
    organizationId: OrganizationPublicId,
    createUser: CreateUserRequest,
  ) => {
    const url = Helpers.organizationAdminInviteUser(organizationId);
    const response = await this.axios.post<OrganizationUserDto>(url, createUser);

    return response.data as OrganizationUserDto;
  };

  public activateUser = async (organizationId: OrganizationPublicId, email: string) => {
    const url = Helpers.organizationAdminActivateUser(organizationId, email);
    const response = await this.axios.post<OrganizationUserDto>(url);

    return response.data as OrganizationUserDto;
  };

  public deactivateUser = async (organizationId: OrganizationPublicId, email: string) => {
    const url = Helpers.organizationAdminDeactivateUser(organizationId, email);
    const response = await this.axios.post<OrganizationUserDto>(url);

    return response.data as OrganizationUserDto;
  };

  public deleteUser = async (organizationId: OrganizationPublicId, email: string) => {
    const url = Helpers.organizationAdminSpecificUser(organizationId, email);
    const response = await this.axios.delete<OrganizationUserDto>(url);

    return response.data as OrganizationUserDto;
  };

  public assignUserRole = async (
    organizationId: OrganizationPublicId,
    email: string,
    newRole: UserRole,
  ) => {
    const url = Helpers.organizationAdminAssignUserRole(organizationId, email);
    await this.axios.post<void>(url, { newRole });
  };
}
